import { Box, BoxProps, ColorOptions, Image, ImageProps, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
const upiHub = require('../../assets/images/one-qr-jiopay.png')

export const JiopayOneQr = () => {
  const { textSize, headerSize } = useFontSize()
  const resPadding = usePadding()
  const viewPortWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewPortWidth)
  const styles = style(isMob)

  const rightArrow = require('../../assets/images/arrow-right-blue.png')
  const newTag = require('../../assets/svg/newtag.svg')
  const { navigate } = useNavigation()
  return (
    <Box {...styles.mainContainer}>
      <Box {...styles.leftContainer}>
        <Image {...styles.imageBox} source={upiHub} />
      </Box>
      <Box {...styles.rightContainer}>
        <Box>
          <Box flexDirection={'row'} align={'center'}>
            <Text
              title={staticStrings.jiopay1Qr}
              fontFamily={'jiotype-black'}
              fontSize={headerSize}
              color={'BLACK_21'}
            />
            <Spacer direction={'horizontal'} size={8} />
            <Image source={newTag} height={isMob ? 16 : 25} width={65} resizeMode="contain" />
          </Box>
          <Spacer size={16} />
          <Box paddingRight={isMob ? resPadding : 0.8 * resPadding}>
            <Text
              title={staticStrings.jiopay1QrSubTitle}
              fontFamily={'jiotype-medium'}
              fontSize={textSize}
              color={'BLACK_21'}
              opacity={0.9}
              lineHeight={isMob ? 20 : 28}
            />
            <Box
              marginTop={24}
              flexDirection="row"
              alignItems="center"
              underlayColor={'TRANSPARENT'}
              onPress={() => navigate('oneqr')}>
              <Text color={colors.HIGHLIGHT as ColorOptions} fontFamily="jiotype-medium" fontSize={isMob ? 14 : 18}>
                {'Know More'}
              </Text>
              <Spacer direction={'horizontal'} size={isMob ? 4 : 8} />
              <Image source={rightArrow} height={isMob ? 16 : 24} width={isMob ? 16 : 24} resizeMode="contain" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const style = (isMob: boolean) => {
  return {
    mainContainer: {
      justify: 'space-between',
      marginTop: 120,
      flexDirection: isMob ? 'column' : 'row',
    } as BoxProps,
    rightContainer: {
      f: isMob ? undefined : 0.5,
      justify: 'center',
    } as BoxProps,
    leftContainer: {
      f: isMob ? undefined : 0.5,
    } as BoxProps,
    imageBox: {
      width: isMob ? '100%' : 400,
      height: isMob ? 360 : 400,
      resizeMode: 'cover',
    } as ImageProps,
  }
}
